import { Image } from "rebass/styled-components";

import DrunkLogo from "../../../../../assets/images/misc/logo-404a.png";
import { PageHeader } from "components/molecules/pageHeader";
import { StyledWrapper } from "../../styledComponents";

export const Error = () => {
  return (
    <StyledWrapper>
      <PageHeader
        z1
        title="Oops! Something went wrong."
        image={<Image src={DrunkLogo} mb={7} maxWidth="180px" />}
      />
    </StyledWrapper>
  );
};
